import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { UserMfaDialogComponent } from './user-mfa-dialog.component'

@Injectable({ providedIn: 'root' })
export class UserMFADialogService {
  constructor(private dialog: MatDialog) {}

  public open() {
    const defaultConfig: MatDialogConfig = {
      width: '600px',
      height: 'auto',
      data: {},
      panelClass: ['variable-modal'],
    }
    return this.dialog.open(UserMfaDialogComponent, defaultConfig)
  }
}
